module.exports = __webpack_public_path__ + "static/img/xeogen-renewal.0982cfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/xeogen-renewal.jpg
// module id = 87IT
// module chunks = 0